"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StableID = void 0;
const Hashing_1 = require("./Hashing");
const Log_1 = require("./Log");
const StorageProvider_1 = require("./StorageProvider");
const UUID_1 = require("./UUID");
const PROMISE_MAP = {};
exports.StableID = {
    get: (sdkKey) => __awaiter(void 0, void 0, void 0, function* () {
        if (PROMISE_MAP[sdkKey] == null) {
            PROMISE_MAP[sdkKey] = _loadFromStorage(sdkKey).then((stableID) => {
                if (stableID != null) {
                    return stableID;
                }
                const newStableID = (0, UUID_1.getUUID)();
                _persistToStorage(newStableID, sdkKey);
                return newStableID;
            });
        }
        return PROMISE_MAP[sdkKey];
    }),
    setOverride: (override, sdkKey) => {
        PROMISE_MAP[sdkKey] = Promise.resolve(override);
        _persistToStorage(override, sdkKey);
    },
};
function _getStableIDStorageKey(sdkKey) {
    return `statsig.stable_id.${(0, Hashing_1.DJB2)(sdkKey)}`;
}
function _persistToStorage(stableID, sdkKey) {
    const storageKey = _getStableIDStorageKey(sdkKey);
    (0, StorageProvider_1._setObjectInStorage)(storageKey, stableID).catch(() => {
        Log_1.Log.warn('Failed to save StableID');
    });
}
function _loadFromStorage(sdkKey) {
    const storageKey = _getStableIDStorageKey(sdkKey);
    return (0, StorageProvider_1._getObjectFromStorage)(storageKey);
}
